export default {"src":"/_next/static/media/cheveron-down-gray.2ef95b9c.svg","height":9,"width":15,"blurWidth":0,"blurHeight":0};